import React from 'react';
import { slide as HamburgerMenu } from 'react-burger-menu';
import { clickifyPhoneNumber, capitalizeFirstLetter } from "Utils/Utils";
// import useVipAccountCache from "Utils/Hooks/useVipAccountCached";
import useSession from "Utils/Hooks/useSession";
import { useHistory } from "react-router-dom";
import { PRODUCTTYPES } from "Utils/Constants";
import VIPPreferredLogo from "Assets/Img/vipp-logo.png";
import VIPOnlineLogo from "Assets/Img/vipo-logo.png";
import help from "Assets/Icons/help-blue.svg";
import profile from "Assets/Icons/profile-blue.svg";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import useMode from "Utils/Hooks/useMode";
import { faro } from "@grafana/faro-react";

import './Menu.scss';

const Menu = ({ firstName, lastName }) => {
  // const { vipAccount } = useVipAccountCache();
  const mode = useMode();
  const { session, invalidateSession } = useSession();
  const history = useHistory();
  const vipApi = useVipApiFetcher();
  const logoutAction = async () => {
    await NotifyLogout();
  };
  const isVIPPreferred = session?.patronProductType === PRODUCTTYPES.PREFERRED;
  const productType = isVIPPreferred ? 'VIP Preferred' : 'VIP Online';
  const logoSrc = isVIPPreferred ? VIPPreferredLogo : VIPOnlineLogo;

  async function NotifyLogout() {
    const sessionId = JSON.parse(global.sessionStorage.getItem("vip-patron-session")).sessionId;
    if (!session.transactionSucceeded) {
      vipApi
        .fetch("/api/usertracking/cancelflow", "POST", {
          transactionStage: mode === "withdraw" ? "Withdrawal" : "Deposit",
          sessionId: sessionId,
        })
        .then((response) => {
          if (response.ok) {
            faro.api.pushEvent("User logged out");
            invalidateSession();
            history.push("/logout");
          } else {
            faro.api.pushError(new Error("Logout Request Error"), { context: response });
            if (response.status === 500) {
              console.error(response.statusText);
              history.push({
                pathname: "/error",
              });
            } else if (response.status === 401) {
              console.error(response.statusText);
              history.push({
                pathname: "/expired",
              });
            } else {
              response.json().then((data) => {
                console.error(data);
                onError(data);
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          faro.api.pushError(new Error("Logout Network Error"), { context: error });
          history.push({
            pathname: "/error",
          });
        });
    } else {
      invalidateSession();
      history.push("/logout");
    }
  }

  function onError(response) {
    history.push({
      pathname: "/error",
      state: {
        isError: true,
        showButton: true,
        title: "Request Failed. Please Try Again",
        message:
          response.patronErrorMessage ??
          "We are unable to complete this request. Please contact our Customer Service Team at 1-800-500-1973. Reference code E-30 so that we may better serve you.",
        allowRetry: false,
      },
    });
  }
  
  return (
    <HamburgerMenu right className="hamburger-menu">
      <div className="menu-item logo">
        <div onClick={() => {history.push('dashboard')}}><img className="vip-preferred" src={logoSrc} alt={productType} /></div>
      </div>
      <div className="menu-item welcome left">
          <img className="top-menu-icon" alt="Profile" src={profile} />
          Welcome, {capitalizeFirstLetter(firstName)} {capitalizeFirstLetter(lastName)}!
          <div className="menu-item left">
          <button className="link logout-menu-link click-menu-logout" onClick={logoutAction}>
          Close {productType}
          </button>
          </div>
      </div>      
      <span className="line"></span>
      <div className="menu-item left">
        <img className="top-menu-icon" alt="Help" src={help} />
        <span className="small-text">Need support? Call CAMS:</span><br /><div className="phone-number left">{clickifyPhoneNumber('1-800-500-1973')}</div>
      </div>
    </HamburgerMenu>
  );
};

export default Menu;